import { render, staticRenderFns } from "./txth_add.vue?vue&type=template&id=fa3d41bc&"
import script from "./txth_add.vue?vue&type=script&lang=js&"
export * from "./txth_add.vue?vue&type=script&lang=js&"
import style0 from "./txth_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports